import https from "@/commonJS/https";

//用户登录
export const userLogin = params => {
    return new Promise((resolve, reject) => {
        https
            .post("/member/wechat/login", params)
            .then(res => resolve(res))
            .catch(err => reject(err));
    });
};

//登陆检查
export const checkLoginApi = params => {
    return new Promise((resolve, reject) => {
        https
            .get("login/check_login", params)
            .then(res => resolve(res))
            .catch(err => reject(err));
    });
};

//创建诗歌
export const createTale = params => {
    return new Promise((resolve, reject) => {
        https
            .post("works/create", params)
            .then(res => resolve(res))
            .catch(err => reject(err));
    });
};

//获取我的详情
export const getMyInfo = params => {
    return new Promise((resolve, reject) => {
        https
            .post("member/info", params)
            .then(res => resolve(res))
            .catch(err => reject(err));
    });
};


//获取其他用户详情
export const getUserInfo = params => {
    return new Promise((resolve, reject) => {
        https
            .get("member/getMemberInfo", params)
            .then(res => resolve(res))
            .catch(err => reject(err));
    });
};

//获取我的作品
export const getMyTale = params => {
    return new Promise((resolve, reject) => {
        https
            .get("member/workPage", params)
            .then(res => resolve(res))
            .catch(err => reject(err));
    });
};

//获取我的收藏
export const getMyCollection = params => {
    return new Promise((resolve, reject) => {
        https
            .get("member/collectPage", params)
            .then(res => resolve(res))
            .catch(err => reject(err));
    });
};

//获取我的关注
export const getMyAttention = params => {
    return new Promise((resolve, reject) => {
        https
            .get("member/attentionPage", params)
            .then(res => resolve(res))
            .catch(err => reject(err));
    });
};

//获取我的点赞
export const getMyVote = params => {
    return new Promise((resolve, reject) => {
        https
            .get("member/likePage", params)
            .then(res => resolve(res))
            .catch(err => reject(err));
    });
};

//随机作品
export const getRoundWork = params => {
    return new Promise((resolve, reject) => {
        https
            .get("works/getRoundWork", params)
            .then(res => resolve(res))
            .catch(err => reject(err));
    });
};

//点赞
export const postLike = params => {
    return new Promise((resolve, reject) => {
        https
            .post("works/like", params)
            .then(res => resolve(res))
            .catch(err => reject(err));
    });
};
//收藏
export const postCollection = params => {
    return new Promise((resolve, reject) => {
        https
            .post("works/collect", params)
            .then(res => resolve(res))
            .catch(err => reject(err));
    });
};

//关注
export const postAttention = params => {
    return new Promise((resolve, reject) => {
        https
            .post("member/attention", params)
            .then(res => resolve(res))
            .catch(err => reject(err));
    });
};

//获取榜单日期列表
export const getRankingDate = params => {
    return new Promise((resolve, reject) => {
        https
            .get("rank/dateList", params)
            .then(res => resolve(res))
            .catch(err => reject(err));
    });
};

//获取榜单列表
export const getRankingList = params => {
    return new Promise((resolve, reject) => {
        https
            .get("rank/list", params)
            .then(res => resolve(res))
            .catch(err => reject(err));
    });
};


//判断是否已点赞收藏
export const postStatus = params => {
    return new Promise((resolve, reject) => {
        https
            .get("works/getWorkMemberStatus", params)
            .then(res => resolve(res))
            .catch(err => reject(err));
    });
};

//获取排名
export const getRanking = params => {
    return new Promise((resolve, reject) => {
        https
            .get("member/ranking", params)
            .then(res => resolve(res))
            .catch(err => reject(err));
    });
};

//完善资料
export const postPerfectData = params => {
    return new Promise((resolve, reject) => {
        https
            .post("member/perfectData", params)
            .then(res => resolve(res))
            .catch(err => reject(err));
    });
};

//隐藏微信浏览器菜单
export const hiddenMenu = (url, openid) => {
    return https
        .get("user/getShareInfo", {
            url,
            openid
        })
        .then(res => {
            wx.config({
                debug: false,
                appId: res.data.appid,
                timestamp: res.data.timestamp,
                nonceStr: res.data.noncestr,
                signature: res.data.signature,
                jsApiList: ["hideMenuItems"]
            });
            wx.ready(function () {
                wx.hideOptionMenu();
            });
        });
};


//普通分享
export const shareFunTmj = (url) => {
    return https
        .get("other/getWxJsSign", {
            url
        })
        .then(res => {
            wx.config({
                debug: false,
                appId: res.data.appId,
                timestamp: res.data.timestamp,
                nonceStr: res.data.nonceStr,
                signature: res.data.sign,
                jsApiList: [
                    "updateAppMessageShareData",
                    "updateTimelineShareData",
                    "showOptionMenu",
                    "onMenuShareAppMessage",
                    "onMenuShareTimeline"
                ]
            });
            wx.ready(function () {
                let shareConfig = {
                    title: '“梳情诗”——2023征集活动正在进行中',
                    desc: '为生活而创',
                    link: 'http://sqs.ctans.com/#/',
                    imgUrl: 'http://sqs.ctans.com/lynic-share.jpg',
                    success: function () { }
                };

                //需在用户可能点击分享按钮前就先调用
                if (
                    !/Android|webOS|iPhone|iPod|BlackBerry/i.test(
                        navigator.userAgent
                    )
                ) {
                    wx.onMenuShareAppMessage(shareConfig);
                    wx.onMenuShareTimeline(shareConfig);
                } else {
                    wx.updateAppMessageShareData(shareConfig);
                    wx.updateTimelineShareData(shareConfig);
                }

                wx.showOptionMenu();
            });
        });
};

export const shareFunlistTmj = (url) => {
    return https
        .get("other/getWxJsSign", {
            url
        })
        .then(res => {
            wx.config({
                debug: false,
                appId: res.data.appId,
                timestamp: res.data.timestamp,
                nonceStr: res.data.nonceStr,
                signature: res.data.sign,
                jsApiList: [
                    "updateAppMessageShareData",
                    "updateTimelineShareData",
                    "showOptionMenu",
                    "onMenuShareAppMessage",
                    "onMenuShareTimeline"
                ]
            });
            wx.ready(function () {
                let shareConfig = {
                    title: '“梳情诗”——2023征集活动正在进行中',
                    desc: '为生活而创',
                    link: 'http://sqs.ctans.com/#/list',
                    imgUrl: 'http://sqs.ctans.com/lynic-share.jpg',
                    success: function () { }
                };

                //需在用户可能点击分享按钮前就先调用
                if (
                    !/Android|webOS|iPhone|iPod|BlackBerry/i.test(
                        navigator.userAgent
                    )
                ) {
                    wx.onMenuShareAppMessage(shareConfig);
                    wx.onMenuShareTimeline(shareConfig);
                } else {
                    wx.updateAppMessageShareData(shareConfig);
                    wx.updateTimelineShareData(shareConfig);
                }

                wx.showOptionMenu();
            });
        });
};


//详情分享
export const shareFunTmjInfo = (url, data) => {
    return https
        .get("other/getWxJsSign", {
            url
        })
        .then(res => {
            wx.config({
                debug: false,
                appId: res.data.appId,
                timestamp: res.data.timestamp,
                nonceStr: res.data.nonceStr,
                signature: res.data.sign,
                jsApiList: [
                    "updateAppMessageShareData",
                    "updateTimelineShareData",
                    "showOptionMenu",
                    "onMenuShareAppMessage",
                    "onMenuShareTimeline"
                ]
            });
            wx.ready(function () {
                let shareConfig = {
                    title: data.title,
                    desc: data.author,
                    link: 'http://sqs.ctans.com/#/taleInfo?data=' + data.id,
                    imgUrl: 'http://sqs.ctans.com/lynic-share.jpg',
                    success: function () { }
                };

                //需在用户可能点击分享按钮前就先调用
                if (
                    !/Android|webOS|iPhone|iPod|BlackBerry/i.test(
                        navigator.userAgent
                    )
                ) {
                    wx.onMenuShareAppMessage(shareConfig);
                    wx.onMenuShareTimeline(shareConfig);
                } else {
                    wx.updateAppMessageShareData(shareConfig);
                    wx.updateTimelineShareData(shareConfig);
                }

                wx.showOptionMenu();
            });
        });
};

//分享排行
export const shareFunRankingTmj = (url) => {
    return https
        .get("other/getWxJsSign", {
            url
        })
        .then(res => {
            wx.config({
                debug: false,
                appId: res.data.appId,
                timestamp: res.data.timestamp,
                nonceStr: res.data.nonceStr,
                signature: res.data.sign,
                jsApiList: [
                    "updateAppMessageShareData",
                    "updateTimelineShareData",
                    "showOptionMenu",
                    "onMenuShareAppMessage",
                    "onMenuShareTimeline"
                ]
            });
            wx.ready(function () {
                let shareConfig = {
                    title: '“梳情诗”排行榜',
                    desc: '为生活而创',
                    link: 'http://sqs.ctans.com/#/ranking',
                    imgUrl: 'http://sqs.ctans.com/lynic-share.jpg',
                    success: function () { }
                };

                //需在用户可能点击分享按钮前就先调用
                if (
                    !/Android|webOS|iPhone|iPod|BlackBerry/i.test(
                        navigator.userAgent
                    )
                ) {
                    wx.onMenuShareAppMessage(shareConfig);
                    wx.onMenuShareTimeline(shareConfig);
                } else {
                    wx.updateAppMessageShareData(shareConfig);
                    wx.updateTimelineShareData(shareConfig);
                }

                wx.showOptionMenu();
            });
        });
};